import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Loading from "../Common/Loading/index";
import { FaLinkedinIn, FaTelegramPlane } from "react-icons/fa";
import { AiOutlineInstagram, AiOutlineTwitter } from "react-icons/ai";
import { SendEmail } from "./Services";
import { Spinner } from "react-bootstrap";
import toast from "react-hot-toast";
import { GoPrimitiveDot } from "react-icons/go";
function Footer({ noMargin }) {
  const { user_type, footerDetails } = useSelector(state => state);
  const renderLink = () => {
    switch (user_type) {
      case "admin":
        return "Admin/Dashboard";
      default:
        return "/User/Dashboard";
    }
  };
  let linkStyle = {
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid #707070",
    borderRadius: "5px",
    height: "68px",
    width: "68px",
    marginLeft: "5px",
  };
  const [state, setState] = useState({ email: "", loading: false });
  const validateEmail = email => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  };
  const handlersend = () => {
    if (state.email != "" && validateEmail(state.email)) {
      setState({ ...state, loading: true });
      SendEmail(state).then(result => {
        setState({
          ...state,
          loading: false,
        });
      });
    } else {
      toast.error("ایمیل درست وارد نشده است");
    }
  };
  return (
    <footer className="nikotan-footer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="d-flex justify-content-start align-items-center p-1">
              <div className="d-none d-sm-flex">
                <img
                  className="nikotan-img"
                  src={window.origin + `/WebSide/assets/images/oldlogo.png`}
                  alt={"nikotan | نیکوتن"}
                />
              </div>
              <div className="d-flex flex-column flex-md-row">
                <div>
                  <img
                    src={window.origin + "/WebSide/assets/images/logo.png"}
                    alt="nikotan | نیکوتن"
                    width={"100px"}
                  />
                </div>
                <div>
                  <img
                    src={window.origin + `/WebSide/assets/images/sam.png`}
                    alt={"nikotan | نیکوتن"}
                    style={{
                      height: "33px",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 order-sm-1 col-sm-8 col-md-5 col-xl-5 mb-2">
            <div className="d-flex flex-column">
              <div className="p-1">
                <h5
                  style={{
                    fontWeight: "500",
                    color: "#000000",
                  }}
                >
                  ارتباط با ما
                </h5>
              </div>
              <div className="mt-2">
                <div className="d-flex justify-content-start align-items-center">
                  <img
                    className="contact-icon"
                    src={window.origin + `/WebSide/assets/images/address.png`}
                    style={{
                      width: "22px",
                      height: "22px",
                    }}
                    alt={"nikotan | نیکوتن"}
                  />
                  <span
                    className="d-flex align-items-center white-space-nowrap"
                    style={{
                      fontWeight: "400",
                    }}
                  >
                    آدرس :
                  </span>
                </div>
                <div
                  className=" d-flex justify-content-evenly justify-content-sm-start"
                  style={{
                    paddingRight: "45px",
                  }}
                >
                  {!footerDetails ? (
                    <span className="row">
                      <Loading
                        count={1}
                        col={window.screen.width > 570 ? 9 : 12}
                        height={27}
                      />
                    </span>
                  ) : (
                    <>
                      <address
                        className=""
                        style={{
                          color: "#000",
                          margin: "0px",
                          fontSize: "12px",
                          fontWeight: "400",
                        }}
                      >
                        {footerDetails.Addres_co}
                      </address>
                    </>
                  )}
                </div>
              </div>
              <div className="mt-2">
                <div className="d-flex justify-content-start align-items-center">
                  <img
                    className="contact-icon"
                    src={
                      window.origin + `/WebSide/assets/images/phone-call.png`
                    }
                    style={{
                      width: "22px",
                      height: "22px",
                    }}
                    alt={"nikotan | نیکوتن"}
                  />
                  <span
                    className="white-space-nowrap"
                    style={{
                      color: "#000000",
                      fontWeight: "400",
                    }}
                  >
                    شماره تماس :
                  </span>
                </div>
                <div className=" d-flex justify-content-evenly ">
                  {!footerDetails ? (
                    <span className="row">
                      <Loading
                        count={1}
                        col={window.screen.width > 570 ? 9 : 12}
                        height={27}
                      />
                    </span>
                  ) : (
                    <>
                      <a
                        href={"tel:" + footerDetails.Tell1_co}
                        style={{
                          color: "#000",
                          fontWeight: "400",
                          fontSize: "14px",
                        }}
                      >
                        {footerDetails.Tell1_co}
                      </a>
                      <a
                        href={"tel:" + footerDetails.Tell2_co}
                        style={{
                          color: "#000",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                      >
                        {footerDetails.Tell2_co}
                      </a>
                    </>
                  )}
                </div>
              </div>
              <div className="">
                <div className="d-flex justify-content-start align-items-center">
                  <img
                    className="contact-icon"
                    src={window.origin + `/WebSide/assets/images/email.png`}
                    alt={"nikotan | نیکوتن"}
                    style={{
                      width: "22px",
                      height: "22px",
                    }}
                  />
                  <span
                    style={{
                      color: "#000000",

                      fontWeight: "400",
                    }}
                    className="white-space-nowrap"
                  >
                    ایمیل :
                  </span>
                </div>
                <div
                  className="d-flex justify-content-evenly justify-content-sm-start"
                  style={{
                    paddingRight: "50px",
                  }}
                >
                  {!footerDetails ? (
                    <span className="row">
                      <Loading
                        count={1}
                        col={window.screen.width > 570 ? 9 : 12}
                        height={27}
                      />
                    </span>
                  ) : (
                    <div className="d-flex flex-column">
                      <a
                        href={"mailto:" + footerDetails.Gmail_co}
                        style={{
                          color: "#000",
                          fontSize: "13px",
                          fontWeight: "400",
                          color: "rgb(27, 160, 216)",
                        }}
                      >
                        ارسال ایمیل
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="order-3 order-sm-2 col-sm-4 col-md-3 col-xl-2 mb-2 md-sm-0">
            <div className="p-1 text-start">
              <h5
                style={{
                  fontWeight: "500",
                  color: "#000000",
                }}
              >
                لینک های مفید
              </h5>
            </div>
            <div className="mt-2 d-flex flex-column text-start">
              <div>
                <Link
                  to={"/MainDetailsSite"}
                  style={{
                    color: "#000",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ marginLeft: "5px" }}>
                    <GoPrimitiveDot />
                  </span>
                  درباره ما
                </Link>
              </div>
              <div className="mt-1">
                <Link
                  to={"/roadmap"}
                  style={{
                    color: "#000",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ marginLeft: "5px" }}>
                    <GoPrimitiveDot />
                  </span>
                  داستان نیکوتن
                </Link>
              </div>
              <div className="mt-1">
                <Link
                  to={"/faq"}
                  style={{
                    color: "#000",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ marginLeft: "5px" }}>
                    <GoPrimitiveDot />
                  </span>
                  سوالات متداول
                </Link>
              </div>
              <div className="mt-1">
                <Link
                  to={"/RulesSite"}
                  style={{
                    color: "#000",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ marginLeft: "5px" }}>
                    <GoPrimitiveDot />
                  </span>
                  قوانین و مقررات
                </Link>
              </div>
              <div className="mt-1">
                <Link
                  to={"/Privacy"}
                  style={{
                    color: "#000",
                    fontWeight: "400",
                    fontSize: "14px",
                  }}
                >
                  <span style={{ marginLeft: "5px" }}>
                    <GoPrimitiveDot />
                  </span>
                  حریم خصوصی
                </Link>
              </div>
            </div>
          </div>
          <div className="order-2 order-sm-3 col-sm-12 col-md-4 col-xl-5">
            <div className="d-flex flex-column">
              <div>
                <div>
                  <h6
                    className="mb-2"
                    style={{
                      color: "#000000",
                      fontWeight: "400",
                      fontSize: "12px",
                    }}
                  >
                    عضویت در خبرنامه ایمیلی :
                  </h6>
                </div>
                <div className="d-flex input-container">
                  <input
                    placeholder="example@gmail.com"
                    onChange={e =>
                      setState({ ...state, email: e.target.value })
                    }
                    type={"email"}
                  />
                  <button
                    className="btn btn-red "
                    disabled={state.email != "" ? false : true}
                    onClick={() => {
                      handlersend();
                    }}
                  >
                    {state.loading ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "عضویت"
                    )}
                  </button>
                </div>
              </div>
              <div className="my-1 my-2">
                <ul className="d-flex justify-content-center  flex-wrap">
                  <li className="inline-block mt-1" style={{ width: "unset" }}>
                    <span
                      referrerPolicy="origin"
                      target="_blank"
                      href=""
                      style={{
                        ...linkStyle,
                      }}
                    >
                      <img
                        alt="کسب و کارهای مجازی"
                        data-src={
                          window.origin +
                          `/WebSide/assets/images/namad/kasbkar.png`
                        }
                        style={{
                          width: "61px",
                          height: "61px",
                          objectFit: "contain",
                        }}
                        data-expand={0}
                        className="is-responsive img-contrast is-animated lazyloaded p-1  "
                        src={
                          window.origin +
                          `/WebSide/assets/images/namad/kasbkar.png`
                        }
                      />
                    </span>
                  </li>
                  <li className="inline-block mt-1" style={{ width: "unset" }}>
                    <span
                      target="_blank"
                      style={{
                        ...linkStyle,
                      }}
                    >
                      <img
                        style={{
                          width: "69px",
                          height: "69px",
                          objectFit: "contain",
                        }}
                        alt="logo-samandehi"
                        data-src={
                          window.origin +
                          `/WebSide/assets/images/namad/samsne.png`
                        }
                        data-expand={0}
                        className="is-responsive img-contrast is-animated lazyloaded p-1 "
                        src={
                          window.origin +
                          `/WebSide/assets/images/namad/samsne.png`
                        }
                      />
                    </span>
                  </li>
                  <li className="inline-block mt-1" style={{ width: "unset" }}>
                    <div className="fotternemadweb"  style={{
                          ...linkStyle,
                        }}>
                      <a referrerpolicy="origin" target="_blank"
                        href="https://trustseal.enamad.ir/?id=161896&amp;Code=qukVSgzkq7uOfxDCxNqB">
                        <img referrerpolicy="origin"
                          src="https://Trustseal.eNamad.ir/logo.aspx?id=161896&amp;Code=qukVSgzkq7uOfxDCxNqB" alt=""
                          style={{ cursor: "pointer" }} id="qukVSgzkq7uOfxDCxNqB" />
                      </a>
                      {/* <a
                        referrerpolicy="origin"
                        target="_blank"
                        href="https://trustseal.enamad.ir/?id=161896&amp;Code=qukVSgzkq7uOfxDCxNqB"
                        style={{
                          ...linkStyle,
                        }}
                        rel="noopener noreferrer"
                      >
                        <img
                          referrerPolicy="origin"
                          src={
                            "https://Trustseal.eNamad.ir/logo.aspx?id=161896&amp;Code=qukVSgzkq7uOfxDCxNqB"
                          }
                          alt="Trustseal.eNamad.ir"
                          style={{ cursor: "pointer" }}
                          id="qukVSgzkq7uOfxDCxNqB"
                        />
                      </a> */}

                    </div>
                  </li>
                  <li className="inline-block mt-1" style={{ width: "unset" }}>
                    <a
                      href="http://saynarazavi.ir"
                      target="_blank"
                      className="footer-card p-1"
                      style={{
                        ...linkStyle,
                      }}
                      rel="noopener noreferrer"
                    >
                      <img
                        alt="وزارت ورزش"
                        data-src={
                          window.origin +
                          `/WebSide/assets/images/namad/vvarzeh.png`
                        }
                        data-expand={0}
                        className="is-responsive is-animated lazyloaded p-1 "
                        src={
                          window.origin +
                          `/WebSide/assets/images/namad/vvarzeh.png`
                        }
                        style={{
                          width: "69px",
                          height: "69px",
                          objectFit: "contain",
                        }}
                      />
                    </a>
                  </li>
                  <li className="inline-block mt-1" style={{ width: "unset" }}>
                    <a
                      href="https://network.kstp.ir/c/189332"
                      target="_blank"
                      className="footer-card p-1"
                      style={{
                        ...linkStyle,
                      }}
                      rel="noopener noreferrer"
                    >
                      <img
                        alt="پارک خراسان"
                        data-src={
                          window.origin +
                          `/WebSide/assets/images/namad/park.png`
                        }
                        style={{
                          width: "69px",
                          height: "69px",
                        }}
                        data-expand={0}
                        className="is-responsive is-animated lazyloaded p-1"
                        src={
                          window.origin +
                          `/WebSide/assets/images/namad/park.png`
                        }
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ backgroundColor: "#404040", fontSize: "10px", color: "#fff" }}
      >
        <div className="d-flex justify-content-center p-2">
          {!footerDetails ? (
            <span className="row mt-2">
              <Loading
                count={1}
                col={window.screen.width > 570 ? 9 : 12}
                height={27}
              />
            </span>
          ) : (
            <>
              <a
                target="_blank"
                href={footerDetails && footerDetails.Linkedin}
                className="social-media-icon"
                style={{ cursor: "pointer" }}
              >
                <FaLinkedinIn size={"4px"} />
              </a>
              <a
                target="_blank"
                href={footerDetails && footerDetails.Instagram}
                className="social-media-icon"
                style={{ cursor: "pointer" }}
              >
                <AiOutlineInstagram />
              </a>
              <a
                target="_blank"
                href={footerDetails && footerDetails.Twitter}
                className="social-media-icon"
                style={{ cursor: "pointer" }}
              >
                <AiOutlineTwitter />
              </a>
              <a
                target="_blank"
                href={footerDetails && footerDetails.Telegram}
                className="social-media-icon"
                style={{ cursor: "pointer" }}
              >
                <FaTelegramPlane />
              </a>
            </>
          )}
        </div>
        <div className="text-center">
          <h6
            style={{
              margin: "0px",
              fontSize: "12px",
              color: "#fff",
              fontWeight: "400",
            }}
          >
            تمامی حقوق مادی و معنوی این سایت متعلق به شرکت ویداسیستم ایرانیان می
            باشد
          </h6>
          <p
            style={{
              color: "#fff",
              fontWeight: "400",
            }}
          >
            &copy; 2015{" "}
            <a
              style={{ padding: "0px", margin: "0px" }}
              href="http://vidasystemiranian.co.ir"
            >
              Vida System Iranian
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
